module.exports = __webpack_public_path__ + "img/quote-down.6f578ed4.svg";